module.exports = __webpack_public_path__ + "img/plyr.269c4ddc.svg";